// extracted by mini-css-extract-plugin
export var active = "_2u-7";
export var container = "_2u-0";
export var evenWidth = "_2u-4";
export var large = "_2u-5";
export var outlet = "_2u-8";
export var slide = "_2u-2";
export var small = "_2u-6";
export var tab = "_2u-3";
export var tabs = "_2u-1";